import { Component, Input } from '@angular/core';
import { CNAEViewer } from '../../adapters';

@Component({
    selector: 'sgt-cnae-form-control-text',
    templateUrl: './cnae-form-control-text.component.html',
    styleUrls: ['./cnae-form-control-text.component.less']
})
export class CNAEFormControlTextComponent {
    @Input() label = 'CNAE';
    @Input() helpText = 'Código e descrição da Atividade Econômica';
    @Input() cnae: CNAEViewer;
}
